import {Injectable} from '@angular/core';
import {ProjectStatus} from "../page/interfaces";

@Injectable({
    providedIn: 'root'
})
export class ProjectService {

    hasStatus(project, status: ProjectStatus | ProjectStatus[]): boolean {
        if (!project) return false;

        const statusList = [].concat(status);

        return statusList.includes(project.status);
    }
}
